// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* giftFilters.css */
.giftFilterComponent {
    position: relative;
    display: flex;
    gap: 8px;
    align-items: center;
}

.giftFilterComponent > label {
    font-size: 13px;
    font-weight: 500;
    color: var(--text-secondary);
    white-space: nowrap;
}

.giftFilter_button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    min-width: 160px;
    padding: 6px 10px;
    border-radius: var(--radius-sm);
    border: 1px solid var(--border);
    font-size: 13px;
    color: var(--text-primary);
    background-color: var(--bg-card);
    cursor: pointer;
}

.giftFilter_arrow {
    color: var(--text-secondary);
    transition: transform var(--transition-fast);
}

.giftFilter_arrow-open {
    transform: rotate(180deg);
}

/* Liste déroulante */
.giftFilter_menu {
    position: absolute;
    top: calc(100% + 4px);
    right: 0;
    z-index: 20;
    display: flex;
    flex-direction: column;
    min-width: 240px;
    max-height: 320px;
    overflow-y: auto;
    padding: 6px;
    border-radius: var(--radius-sm);
    border: 1px solid var(--border);
    background-color: var(--bg-elevated);
    box-shadow: var(--shadow-lg);
}

.giftFilter_option {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 8px;
    border-radius: var(--radius-sm);
    font-size: 13px;
    color: var(--text-primary);
    cursor: pointer;
    white-space: nowrap;
}

.giftFilter_option:hover {
    background-color: var(--primary-light);
}

.giftFilter_selectAll {
    padding: 6px 8px;
    border: none;
    background: none;
    text-align: left;
    font-size: 13px;
    font-weight: 500;
    color: var(--primary);
    cursor: pointer;
}

.giftFilter_selectAll:hover {
    color: var(--primary-hover);
}
`, "",{"version":3,"sources":["webpack://./src/components/Filters/GiftsFilters/giftFilters.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,+BAA+B;IAC/B,+BAA+B;IAC/B,eAAe;IACf,0BAA0B;IAC1B,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,4CAA4C;AAChD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,+BAA+B;IAC/B,+BAA+B;IAC/B,oCAAoC;IACpC,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,+BAA+B;IAC/B,eAAe;IACf,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":["/* giftFilters.css */\n.giftFilterComponent {\n    position: relative;\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.giftFilterComponent > label {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--text-secondary);\n    white-space: nowrap;\n}\n\n.giftFilter_button {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    min-width: 160px;\n    padding: 6px 10px;\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--border);\n    font-size: 13px;\n    color: var(--text-primary);\n    background-color: var(--bg-card);\n    cursor: pointer;\n}\n\n.giftFilter_arrow {\n    color: var(--text-secondary);\n    transition: transform var(--transition-fast);\n}\n\n.giftFilter_arrow-open {\n    transform: rotate(180deg);\n}\n\n/* Liste déroulante */\n.giftFilter_menu {\n    position: absolute;\n    top: calc(100% + 4px);\n    right: 0;\n    z-index: 20;\n    display: flex;\n    flex-direction: column;\n    min-width: 240px;\n    max-height: 320px;\n    overflow-y: auto;\n    padding: 6px;\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--border);\n    background-color: var(--bg-elevated);\n    box-shadow: var(--shadow-lg);\n}\n\n.giftFilter_option {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 8px;\n    border-radius: var(--radius-sm);\n    font-size: 13px;\n    color: var(--text-primary);\n    cursor: pointer;\n    white-space: nowrap;\n}\n\n.giftFilter_option:hover {\n    background-color: var(--primary-light);\n}\n\n.giftFilter_selectAll {\n    padding: 6px 8px;\n    border: none;\n    background: none;\n    text-align: left;\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--primary);\n    cursor: pointer;\n}\n\n.giftFilter_selectAll:hover {\n    color: var(--primary-hover);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
